import './DesktopMenuItem.css';

import React, { useContext } from 'react';

import ColorContext from '../../context/ColorContext';
import { Maybe } from '../../types/wordpress/node';
import compact from '../../utils/helpers/compact';
import { tw } from '../../utils/tailwind';
import { Box, Stack } from '../Core';
import StyledLink from '../StyledLink';
import MenuItem from '.';

interface IDesktopMenuItemProps {
  color?: string;
  currentPath: string;
  isActivePage: boolean;
  isSubmenuItem: boolean;
  menuItem: MenuItem;
  styledLinkDestination: Maybe<{
    href?: string;
    to?: string;
    isEmail?: boolean;
    shouldObfuscate?: boolean;
  }>;
}

const DesktopMenuItem: FCWithClassName<IDesktopMenuItemProps> = (props) => {
  const { isActivePage, menuItem, isSubmenuItem } = props;
  const {theme} = useContext(ColorContext);
  const accentColor =
    theme === 'institute' ? 'text-primaryInstitute' : 'text-primaryMain';
  const hoverColor = theme === 'institute' ? 'hover:text-text' : 'hover:text-primaryMain';
  const subMenuItems = compact(menuItem?.childItems?.nodes).map((childItem) => {
    if (!childItem) return undefined;
    return (
      <MenuItem
        allowSubmenu={false}
        color="text"
        currentPath={props.currentPath}
        key={childItem.id}
        isActivePage={isActivePage}
        isSubmenuItem
        menuType="desktop"
        menuItem={{
          ...childItem,
          childItems: undefined,
          locations: undefined,
          parentId: undefined,
        }}
      />
    );
  });
  const parentMenuItem = (
    <Box className="relative cursor-pointer menu-item ">
      <StyledLink
        className={tw(
          '!uppercase font-label menu-item text-text text-5',
          isActivePage ? accentColor : null,
          hoverColor,
          props.className
        )}
        style={{ color: props.color }}
        {...props.styledLinkDestination}
        variant="navigationLink"
      >
        {props.menuItem?.label}
      </StyledLink>
      {Boolean(subMenuItems.length) && (
        <Stack className="absolute invisible p-4 transition-opacity bg-white opacity-0 submenu-items w-fit ">
          {subMenuItems}
        </Stack>
      )}
    </Box>
  );
  const submenuItem = (
    <StyledLink
      {...props.styledLinkDestination}
      className={tw(
        'block mr-0 !uppercase font-label menu-item hover:text-primaryMain text-text text-5 whitespace-pre',
        isActivePage ? 'text-primaryMain' : '',
        props.className
      )}
      style={{ color: props.color }}
    >
      {props.menuItem?.label}
    </StyledLink>
  );
  return isSubmenuItem ? submenuItem : parentMenuItem;
};

export default DesktopMenuItem;
